angular.module('core')
  .service('cancelableResourceManager', ['$rootScope', 'uidFactory', function($rootScope, $uidFactory) {

    var resources = {};

    var addAndRemoveOnFinish = function(resource) {
      var pid = add(resource);
      resource.$promise.finally(function() {
        remove(pid);
      });
    };

    /**
     * @param resource
     * @returns {id:String}
     */
    var add = function(resource) {
      var id = $uidFactory.create();
      resources[id] = resource;
      return id;
    };

    var remove = function(id) {
      delete resources[id];
    };

    var cancelAll = function() {
      _.invoke(resources, 'cancel');
      resources = {};
    };

    var getList = function() {
        return resources;
    };

    $rootScope.$on('$stateChangeStart', function() {
      cancelAll();
    });

    return {
      add: add,
      addAndRemoveOnFinish: addAndRemoveOnFinish,
      cancelAll: cancelAll,
      remove: remove,
      getList: getList
    };

}]);
